<template>
  <router-link :to="{ name: 'DashboardSearch' }" title="Rechercher un profil COOLOC" tag="div" class="menu-icon">
    <div>
      <img src="/static/images/icons/Search.svg"/>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'header-menu-search',
}
</script>
